import React from 'react'
import useSWR from 'swr'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import StatTile from '../../shared/StatTile'

export default withTranslation()(function BranchesSummary({ t }) {
  const { data } = useSWR('merchants/branches')
  const branches = data?.data ?? []
  const active = branches.filter((branch) => branch.status === 'active').length

  return (
    <div className="grid gap-4 md:grid-cols-3 mb-5">
      <StatTile
        icon={UIcons.UilStore}
        label={t('settings.business_organization.branches.total')}
        value={branches.length}
        tone="info"
        tinted
      />

      <StatTile
        icon={UIcons.UilCheckCircle}
        label={t('settings.business_organization.branches.active')}
        value={active}
        tone="success"
        tinted
      />

      <StatTile
        icon={UIcons.UilTimesCircle}
        label={t('settings.business_organization.branches.inactive')}
        value={branches.length - active}
        tone="danger"
        tinted
      />
    </div>
  )
})
